// DEV 表示开发服务器；部署后的 dev/test 构建需按 mode 显式开启。
export const developerToolsEnabled =
  import.meta.env.DEV || import.meta.env.MODE === "dev" || import.meta.env.MODE === "test";

export const envConfig = {
  mode: import.meta.env.MODE || "dev",
  baseUrl: import.meta.env.VITE_BASE_URL || "/",
  apiUrl: import.meta.env.VITE_API_URL || "",
  apiPrefix: import.meta.env.VITE_API_URL_PREFIX || "/api",
  apiProxyEnabled: import.meta.env.VITE_API_PROXY_ENABLED === "true",
  subdomain: import.meta.env.VITE_SUBDOMAIN || "",
};

export function getApiBaseUrl() {
  if (envConfig.mode === "mock" || envConfig.apiProxyEnabled || !envConfig.apiUrl) {
    return envConfig.apiPrefix;
  }

  return `${envConfig.apiUrl}${envConfig.apiPrefix}`;
}
